<p-tabView>
  <p-tabPanel header="Tipo Parte">
    <div class="p-fluid">
      <div class="p-field p-grid">
        <label for="id" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Id:</label>
        <div class="p-col-12 p-lg-10">
          <input pInputText type="text" name="id" disabled [ngModel]="entidade.id" />
        </div>
      </div>
      <div class="p-field p-grid">
        <label for="nome" class="p-col-12 p-mb-2 p-md-2 p-mb-md-0">Nome:</label>
          <div class="p-col-12 p-lg-10">
            <input pInputText type="text" name="nome" disabled [(ngModel)]="entidade.nome" />
          </div>
        </div>
      </div>
  </p-tabPanel>
  <p-tabPanel header="Auditoria" [disabled]="entidade.id === undefined">
    <div class="p-fluid">
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaDataInsercao | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Inserção - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuarioInsercao?.nome}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Data:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaData | date: 'dd/MM/yyyy HH:mm:ss'}}</div>
      </div>
      <div class="p-grid">
        <div class="p-col-12 p-lg-3 p-text-bold">Última alteração - Usuário:</div>
        <div class="p-col-12 p-lg-9">{{entidade.auditoriaUsuario?.nome}}</div>
      </div>
    </div>
  </p-tabPanel>
</p-tabView>
